//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AppPermissionsSetRoleList from "./AppPermissionsSetRoleList.vue";

export default {
    name: "AppSetPermissions",
    components: {
        AppPermissionsSetRoleList,
        AQModal,
        AQDropdown,
        AQCard
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {}
        },
        excludeApps: {
            type: Array,
            default: () => []
        },
        hideNotifications: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedPermissions: [],
            selectedAppId: "",
            hideAlreadySelectedApps: [],
            hasAdd: {
                label: this.$t("admin.usersAndRoles.addGroupMembers.addButtonTitle"),
                disabled: true
            },
            hasSave: {},
            editPermissionModal: true,
            applicationsOptions: [],
            searchAppValue: "",
            optionsMenu: "",
            appsPayload: {
                pageSize: 50,
                pageNumber: 0,
                searchValue: ""
            },
            appsMod: [],
            initialPerm: "",
            defaultAppValue: "",
            initialPermissionsRoles: [],
            allPermissions: []
        };
    },
    computed: {
        ...mapGetters("apps", ["apps"]),
        getAllApplicationsProps() {
            return {
                placeholder: this.$t("appSetPermissions.placeholderApp"),
                options: this.applicationsOptions,
                addSearch: true,
                hasPagination: true,
                disable: !!this.data.id
            };
        },
        disableSelectApp() {
            return !this.initialPermissions.length;
        },
        checkIfEditPermission() {
            return !!(this.data && this.data.id);
        }
    },
    watch: {
        data: {
            handler(newValue) {
                if (newValue && newValue.id) {
                    this.selectedAppId = newValue.id;
                    if (newValue.permissions) {
                        this.isDisabled = false;
                        this.hasSave = {};
                        this.initialPermissionsRoles = newValue.permissions;
                        this.selectedPermissions = newValue.permissions.map(({ code, id }) => (code === "INITIATOR" && id ? id : code));
                        this.initialPerm = JSON.stringify(this.selectedPermissions);
                    } else {
                        this.isDisabled = true;
                        this.hasSave = { tooltip: this.$t("appSetPermissions.requiredMsgPerm") };
                    }
                } else {
                    this.isDisabled = true;
                    this.hasSave = { tooltip: this.$t("appSetPermissions.requiredMsgPerm") };
                }
            },
            immediate: true
        },
        selectedPermissions(newValue) {
            this.hasAdd.disabled = JSON.stringify(newValue) === this.initialPerm;
            if (!this.checkIfEditPermission && this.selectedAppId && (!newValue || !newValue.length)) {
                this.isDisabled = true;
                this.hasSave = { tooltip: this.$t("appSetPermissions.requiredMsgPerm") };
            } else {
                this.isDisabled = false;
                this.hasSave = {};
            }
        },
        excludeApps: {
            handler(newValue) {
                if (newValue && newValue.length && this.data && this.data.id) {
                    this.hideAlreadySelectedApps = newValue.filter(id => id !== this.data.id);
                } else {
                    this.hideAlreadySelectedApps = newValue;
                }
                if (this.data.id) {
                    this.getAppsByIds([this.data.id]).then(data => {
                        this.setAllAppsOptions(data);
                        this.defaultAppValue = [this.data.id];
                    });
                }
            },
            immediate: true
        },
        searchAppValue: {
            handler(value) {
                if (value) {
                    const searchV = value.trim();
                    if (searchV && searchV.length > 3) {
                        this.appsPayload.pageNumber = 0;
                        this.searchAppsData(searchV);
                    }
                } else {
                    this.appsPayload.pageNumber = 0;
                    this.searchAppsData();
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions("apps", ["getAppsWithPagination", "getAppsByIds"]),
        searchAppsData(value, loadMore, fromScroll) {
            this.appsPayload.searchValue = value || "";
            this.appsPayload.pageSize = 50;
            if (loadMore) {
                this.appsPayload.pageNumber++;
                this.getAllAppsOptions(loadMore, fromScroll);
            } else {
                this.getAllAppsOptions();
            }
        },
        getAllPermissions(data) {
            this.allPermissions = data;
        },
        getAllAppsOptions(load, fromScroll) {
            this.getAppsWithPagination(this.appsPayload).then(data => {
                if (data && data.length) {
                    this.setAllAppsOptions(data, load);
                } else if (!fromScroll) {
                    this.applicationsOptions = [{ label: this.$t("applicationPermissions.noResultsFound"), itemDisabled: true }];
                }
            });
        },
        getSearchValue(value) {
            this.searchAppValue = value;
        },
        hideAppsDDL() {
            this.searchAppValue = "";
        },
        showResults() {
            this.optionsMenu = this.$refs.applicationsRef.$refs.menuDropdown.$children[0].$children[0].$children[1].$el;
            if (this.optionsMenu && this.optionsMenu.offsetHeight) {
                const checkSearch = this.optionsMenu.offsetHeight < 100;
                if (checkSearch) {
                    this.optionsMenu = this.$refs.applicationsRef.$refs.menuDropdown.$children[0].$children[0].$children[0].$el;
                }
            }
            this.optionsMenu.addEventListener("scroll", () => {
                if (this.optionsMenu.offsetHeight + this.optionsMenu.scrollTop >= this.optionsMenu.scrollHeight && !this.searchAppValue) {
                    this.searchAppsData(null, true, true);
                }
            });
        },
        getDynamicPermissions(data) {
            this.$emit("dynamicPermissions", data);
        },
        actionModal($event) {
            if ($event === "primary") {
                if (this.checkConditions()) {
                    if (this.selectedPermissions.length) {
                        const getSelectedPermissionsRoles = () => {
                            const returnSelected = [];
                            this.selectedPermissions.forEach(selectedCode => {
                                const roleSelected = this.allPermissions.find(perm => selectedCode === perm.code
                                || (perm.code === "INITIATOR" && perm.id === selectedCode));
                                if (roleSelected) {
                                    returnSelected.push(roleSelected);
                                }
                            });
                            return returnSelected;
                        };
                        this.$emit("selectedPermissions", { id: this.selectedAppId, permissions: getSelectedPermissionsRoles() });
                        this.editPermissionModal = false;
                        this.$emit("input");
                    } else {
                        this.$emit("removePermission", this.data.currectIndex);
                    }
                }
            } else {
                this.editPermissionModal = false;
                this.$emit("input");
            }
        },
        setAllAppsOptions(data, loadMore) {
            const appsList = data.map(elem => ({
                label: elem.name,
                value: elem.id,
                description: `${this.$t("apps.code")} ${elem.code}` || "N/A"
            }));
            if (loadMore) {
                this.applicationsOptions = this.applicationsOptions.concat(appsList);
            } else {
                this.applicationsOptions = [];
                this.applicationsOptions = appsList;
            }
        },
        selectApp(data) {
            if (!this.data.id) {
                this.selectedAppId = data.length ? data[0].value : "";
                this.selectedPermissions = [];
                this.isDisabled = true;
                this.hasSave = { tooltip: this.$t("appSetPermissions.requiredMsgPerm") };
            }
        },
        checkConditions() {
            if (!this.selectedAppId) {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("appSetPermissions.requiredMsgApp")
                });
            }
            return !!this.selectedAppId;
        }
    }
};
